/* @flow */
import BlockedUser from 'entities/BlockedUser';
import BlockedUsers from 'collections/BlockedUsers';
import BlockedUsersListItem from './BlockedUsersListItem.jsx';
import React from 'react';

import './styles/BlockedUsersList.scss';

export default class BlockedUsersList extends React.Component {
  static propTypes = {
    blockedUsers: React.PropTypes.instanceOf(BlockedUsers).isRequired,
  };

  renderColumnHeaders() {
    return (
      <tr>
        <th>Name</th>
        <th>Date blocked</th>
        <th />
      </tr>
    );
  }

  renderBlockedUser(blockedUser: BlockedUser) {
    return (
      <BlockedUsersListItem
        blockedUser={blockedUser}
        key={blockedUser.id}
      />
    );
  }

  renderBlockedUserList() {
    if (this.props.blockedUsers.length > 0) {
      return this.props.blockedUsers.map(this.renderBlockedUser);
    } else {
      return null;
    }
  }

  render() {
    if (this.props.blockedUsers.length <= 0) {
      return (
        <p className="BlockedUsersList-empty">
          You have no blocked users.
        </p>
      );
    }

    return (
      <table className="BlockedUsersList">
        <thead>
          {this.renderColumnHeaders()}
        </thead>
        <tbody>
          {this.renderBlockedUserList()}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/components/BlockedUsersList.jsx